/*
 * @Author: cheng
 * @Date: 2018-10-29 11:43:10
 * @Last Modified by: cheng
 * @Last Modified time: 2019-02-12 17:23:53
 */
import { cloneDeep } from 'lodash';
import { ModelDeclare, ModelProxy } from '@lib/model-proxy';
import { TestCaseTurn, IntentInfo, CompositeInfo, EntityInfo, ServiceInfo } from '@interface/index';
import { effects } from './effect';

// interface
export interface StateInfo extends AgentParameterCache {
  from: string;
  demoConnected?: boolean;
  testCaseTurns: TestCaseTurn[];
}

export type PayloadInfo = { [K in keyof StateInfo]: StateInfo[K] };


export type AgentParameterCache = {
  agentId: string;
  availableIntents: IntentInfo[];
  availableComposites: CompositeInfo[];
  availableEntities: EntityInfo[];
  availableServices: ServiceInfo[];
  availableChannels: string[];
};

// state
export const defaultState: PayloadInfo = {
  from: '',
  demoConnected: false,
  testCaseTurns: [],
  agentId: '',
  availableIntents: [],
  availableComposites: [],
  availableEntities: [],
  availableServices: [],
  availableChannels: ['restful']
};

const global: ModelDeclare = {
  effects,
  apis: {},
  namespace: 'global',
  state: cloneDeep(defaultState),
  actions: {
    clear: () => (state: PayloadInfo, action: any) => {
      return defaultState;
    },
    intent_update: (state: PayloadInfo, action: any) => {
      const found = state.availableIntents && state.availableIntents.findIndex((item: IntentInfo) =>
        item.id === action.payload.id) !== -1;

      return {
        ...state,
        availableIntents: found
          ? state.availableIntents && state.availableIntents.map((item: IntentInfo) =>
            item.id === action.payload.id ? action.payload : item) || []
          : [
            ...(state.availableIntents || []), action.payload
          ]
      };
    },
    composite_update: (state: PayloadInfo, action: any) => {
      const found = state.availableComposites && state.availableComposites.findIndex((item: CompositeInfo) => item.id === action.payload.id) !== -1;

      return {
        ...state,
        availableComposites: found
          ? state.availableComposites && state.availableComposites.map((item: CompositeInfo) =>
            item.id === action.payload.id ? action.payload : item) || []
          : [
            ...(state.availableComposites || []), action.payload
          ]
      };
    },
    entity_update: (state: PayloadInfo, action: any) => {
      const found = state.availableEntities && state.availableEntities.findIndex((item: EntityInfo) =>
        item.id === action.payload.id) !== -1;

      return {
        ...state,
        availableEntities: found
          ? state.availableEntities && state.availableEntities.map((item: EntityInfo) =>
            item.id === action.payload.id ? action.payload : item) || []
          : [
            ...(state.availableEntities || []), action.payload
          ]
      };
    },
    service_update: (state: PayloadInfo, action: any) => {

      const found = state.availableServices && state.availableServices.findIndex((item: ServiceInfo) =>
        item.id === action.payload.id) !== -1;

      return {
        ...state,
        availableServices: found
          ? state.availableServices && state.availableServices.map((item: ServiceInfo) =>
            item.id === action.payload.id ? action.payload : item) || []
          : [
            ...(state.availableServices || []), action.payload
          ]
      };
    },
    intent_delete: (state: PayloadInfo, action: any) => {

      return {
        ...state,
        availableIntents: state.availableIntents.filter((item: IntentInfo) =>
          item.id !== action.payload)
      };
    },
    composite_delete: (state: PayloadInfo, action: any) => {

      return {
        ...state,
        availableComposites: state.availableComposites.filter((item: CompositeInfo) =>
          item.id !== action.payload)
      };
    },
    entity_delete: (state: PayloadInfo, action: any) => {

      return {
        ...state,
        availableEntities: state.availableEntities.filter((item: EntityInfo) =>
          item.id !== action.payload)
      };
    }
  }
};

export const globalModel = new ModelProxy<StateInfo, PayloadInfo>(global);
